import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(0).addClass("active");
var swiper = new Swiper(".index-banner .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    loop:true,
    speed:2000,
    autoplay: {
        delay: 3000,
    },
    navigation: {
        nextEl: '.index-banner .swiper-button-next',
        prevEl: '.index-banner .swiper-button-prev',
    },
});

// tab切换
$(".section2 ul li").eq(0).addClass("active");
$(".section2 .right .text").eq(0).addClass("active")
$(".section2 .pic img").eq(0).addClass("active");
$(".section2 ul li").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section2 .right .text").eq(index).addClass("active").siblings().removeClass("active");
    $(".section2 .pic img").eq(index).addClass("active").siblings().removeClass("active");
})

const essNav = new Swiper(".ess-nav", {
    slidesPerView: "auto",
    thumbs: {
        swiper: essSwiper,
    },

});

const essSwiper = new Swiper('.ess-swiper', {
    slidesPerView: 2,
    spaceBetween: 70,
    centeredSlides: true,
    loop:true,
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 1.3,
            spaceBetween: 70,
        }
    },
    thumbs: {
        swiper: essNav,
    },
    // on: {
    //   slideChangeTransitionStart: function() {
    //     const activeIndex = this.activeIndex
    //     $(".section3 ul li").each(function (index) {
    //       if (index === activeIndex) {
    //         $(this).addClass('active').siblings().removeClass('active')
    //       }
    //     })
    //   }
    // }
  })
  //解决鼠标悬浮切换效果
//   $(".section3 ul li").mouseenter(function () {
//     $(this).addClass('active').siblings().removeClass('active')
//     essSwiper.slideTo($(this).index() + 1, 300, false);
//   })

